import { Table, Card, Input, Select, Space, Button, Tag } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserList } from "../api/user";

const { Option } = Select;

export default function UserList() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    keyword: "",
    role: "",
    active: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const res = await getUserList(filters);
      setData(res.data);
      setLoading(false);
    };

    fetchData();
  }, [filters]);

  const columns = [
    {
      title: "用户名",
      dataIndex: "username",
    },
    {
      title: "姓名",
      dataIndex: "name",
    },
    {
      title: "电话",
      dataIndex: "phone",
    },
    {
      title: "角色",
      dataIndex: "role",
      render: (role) =>
        role === "admin" ? <Tag color="red">管理员</Tag> : <Tag>普通用户</Tag>,
    },
    {
      title: "状态",
      dataIndex: "active",
      render: (v) => (v ? <Tag color="green">已激活</Tag> : <Tag>未激活</Tag>),
    },
    {
      title: "操作",
      render: (_, record) => (
        <Button type="link" onClick={() => navigate(`/user/${record._id}`)}>
          查看
        </Button>
      ),
    },
  ];

  return (
    <Card title="用户管理">
      <Space style={{ marginBottom: 16 }}>
        <Input
          placeholder="用户名 / 手机 / 邮箱"
          onChange={(e) => setFilters({ ...filters, keyword: e.target.value })}
          allowClear
        />

        <Select
          placeholder="角色"
          style={{ width: 120 }}
          allowClear
          onChange={(v) => setFilters({ ...filters, role: v || "" })}
        >
          <Option value="admin">管理员</Option>
          <Option value="user">普通用户</Option>
        </Select>

        <Select
          placeholder="状态"
          style={{ width: 120 }}
          allowClear
          onChange={(v) => setFilters({ ...filters, active: v })}
        >
          <Option value="true">已激活</Option>
          <Option value="false">未激活</Option>
        </Select>
      </Space>

      <Table
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={data}
      />
    </Card>
  );
}
